import { useState } from "react";
import { fileUrl } from "@/lib/jobOptions";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Image as ImageIcon } from "lucide-react";

/** Lees-only portfoliogalerij: thumbnails + lightbox. */
export function PortfolioGallery({ photos = [], accent = "orange", label = "Portfolio" }) {
  const [active, setActive] = useState(null);
  if (!photos || photos.length === 0) return null;
  const ring = accent === "emerald" ? "hover:border-emerald-400" : accent === "blue" ? "hover:border-blue-400" : "hover:border-orange-400";
  return (
    <div data-testid="portfolio-gallery" className="mt-3">
      <p className="text-[11px] font-bold uppercase tracking-wide text-slate-400 mb-1.5 flex items-center gap-1">
        <ImageIcon className="w-3.5 h-3.5" /> {label} ({photos.length})
      </p>
      <div className="grid grid-cols-3 gap-1.5">
        {photos.map((p) => (
          <button key={p.file_id} type="button" onClick={() => setActive(p)}
            data-testid={`portfolio-thumb-${p.file_id}`}
            className={`relative aspect-square rounded-sm overflow-hidden border border-slate-200 ${ring} transition-colors`}>
            <img src={fileUrl(p.file_id)} alt={p.titel || "Portfolio"} className="w-full h-full object-cover" loading="lazy" />
            {p.titel && (
              <span className="absolute inset-x-0 bottom-0 bg-black/55 text-white text-[9px] px-1 py-0.5 truncate text-left">{p.titel}</span>
            )}
          </button>
        ))}
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-2xl p-0 overflow-hidden bg-slate-950 border-slate-800">
          <DialogTitle className="sr-only">{active?.titel || "Portfoliofoto"}</DialogTitle>
          {active && (
            <div>
              <img src={fileUrl(active.file_id)} alt={active.titel || "Portfolio"} className="w-full max-h-[70vh] object-contain bg-black" />
              {active.titel && <p className="text-white text-sm font-semibold px-4 py-3">{active.titel}</p>}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
